import { lazy } from 'react';

export const CalculationRead = lazy(() =>
    import('./CalculationRead').then((module) => ({ default: module.CalculationRead })),
);
